import React from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import HelpIcon from '@material-ui/icons/Help';
import FormHelperText from '@material-ui/core/FormHelperText';

import {
  ExpansionPanelWrapper,
  FormActionButtons,
  CurrencyInputWrapper,
  PopoverWrapper
} from 'components';

import validate from './validate';

import { useStyles } from './styles';

const initialValues = {
  days: []
};

const PricePerDay = ({ handleSubmit, setSubmitButton, isUpdate }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="days"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={false}
          getTitle={item => item.day}
          children={(field, index, meta) => (
            <div className={classes.prices}>
              <div className={classes.row}>
                <Field
                  name={`${field}.NOK`}
                  label="NOK"
                  isHiddenErrorMsg={true}
                  className={classes.currencyField}
                  component={CurrencyInputWrapper}
                />
                <Field
                  name={`${field}.EUR`}
                  label="EUR"
                  isHiddenErrorMsg={true}
                  className={classes.currencyField}
                  component={CurrencyInputWrapper}
                />
                <Field
                  name={`${field}.USD`}
                  label="USD"
                  isHiddenErrorMsg={true}
                  className={classes.currencyField}
                  component={CurrencyInputWrapper}
                />
                <PopoverWrapper text="Value for at least one currency should be filled in. Currencies marked with zero (or empty) will not be displayed on the widget.">
                  <HelpIcon className={classes.helpIcon} />
                </PopoverWrapper>
              </div>
              {meta.submitFailed && meta.error && meta.error[index] && (
                <FormHelperText error>{t(meta.error[index])}</FormHelperText>
              )}
            </div>
          )}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  pricesDailyForm: state.form.pricesDailyForm
});

export default reduxForm({
  form: 'pricesDailyForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, null)(PricePerDay));
